import {
  CheckCircleFilled,
  FilterOutlined,
  PlusOutlined,
  UndoOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Badge, Button, Tooltip } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import GetFilteredPlanAttributesApi from "../../api/attributes/GetFilteredPlanAttributesApi";
import GetPlanAttributesApi from "../../api/attributes/GetPlanAttributesApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import AddPlanAttributeModal from "../../components/modal/add/AddPlanAttributeModal";
import AttributeFilterModel from "../../components/modal/filters/AttributeFilterModal";
import PageLoader from "../../components/sub/PageLoader";
import PlanAttributesTable from "../../components/tables/PlanAttributesTable";
import { permissionAbility } from "../../helpers/permissionHelpers";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function PlanAttributes() {
  const [addModal, setAddModal] = useState(false);
  const [canStart, setCanStart] = useState(false);
  const [canShowTable, setCanShowTable] = useState(false);
  const [data, setData] = useState();
  const [tableLoading, setTableLoading] = useState(true);
  const [filterModal, setFilterModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const [filterBy, setFilterBy] = useState();
  const [page, setPage] = useState(1);
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;

  useEffect(() => {
    getPlanAttributes(1);
    setFilterBy({ name: "", valueType: "", status: "" });
  }, []);

  async function getPlanAttributes(num) {
    setTableLoading(true);
    const apiResponse = await GetPlanAttributesApi(num, LIMIT_PER_PAGE);
    if (apiResponse.success) {
      if (apiResponse.data?.planAttributes?.length) {
        !canShowTable && setCanShowTable(true);
      }
      setData(apiResponse.data);
      setCanStart(true);
      setTableLoading(false);
      setPage(num);
    }
  }

  async function getFilterPlanAttributes(values, num) {
    setTableLoading(true);
    const apiResponse = await GetFilteredPlanAttributesApi(
      values.name || "",
      values.valueType || "",
      values.status || "",
      num,
      LIMIT_PER_PAGE
    );
    if (apiResponse.success) {
      setData(apiResponse.data);
      setTableLoading(false);
      setFilterStatus(true);
      setFilterBy({
        name: values.name,
        valueType: values.valueType,
        status: values.status,
      });
      setPage(num);
    }
  }

  function changeTablePage(num) {
    if (filterStatus) {
      getFilterPlanAttributes(filterBy, num);
    } else {
      getPlanAttributes(num);
    }
  }

  function resetFilter() {
    getPlanAttributes(1);
    setFilterStatus(false);
    setFilterBy();
  }

  const right = (
    <>
      {canShowTable && (
        <>
          <Tooltip title={"Reset"}>
            <Button
              disabled={!filterStatus}
              onClick={() => resetFilter()}
              className="mr-3"
            >
              <UndoOutlined />
            </Button>
          </Tooltip>
          <Tooltip title={"Filter"}>
            <Badge
              count={
                filterStatus ? (
                  <CheckCircleFilled style={{ color: "#f5222d" }} />
                ) : (
                  0
                )
              }
            >
              <Button onClick={() => setFilterModal(true)}>
                <FilterOutlined />
              </Button>
            </Badge>
          </Tooltip>
        </>
      )}
      {permissionAbility(userLevel, "plan-attributes", "add") && (
        <Tooltip placement="left" title={"Add Attribute"}>
          <Button
            onClick={() => setAddModal(true)}
            shape="circle"
            className="ml-3"
            type="primary"
            icon={<PlusOutlined />}
          ></Button>
        </Tooltip>
      )}
    </>
  );

  const left = (
    <div className="text-lg pri-font">
      {"Plan Attributes (" + (data?.totalCount || 0) + ")"}
    </div>
  );

  function showEmptyPlanGroups() {
    return (
      <div className="flex justify-center items-center w-full h-full">
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-xl pri-font text-gray-400">
            No custom attributes available
          </div>
          {permissionAbility(userLevel, "plan-attributes", "add") && (
            <>
              <div className="mb-3 text-gray-400">
                Add different attributes of your plans
              </div>
              <Button onClick={() => setAddModal(true)} type="primary">
                Add a attribute
              </Button>
            </>
          )}
        </div>
      </div>
    );
  }
  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {canStart ? (
            canShowTable ? (
              <PlanAttributesTable
                changePage={(num) => changeTablePage(num)}
                data={data}
                loading={tableLoading}
                page={page}
              />
            ) : (
              showEmptyPlanGroups()
            )
          ) : (
            <PageLoader />
          )}
        </div>
      </Content>
      <AddPlanAttributeModal
        visible={addModal}
        handleCancel={() => setAddModal(false)}
        handleOk={() => getPlanAttributes(1)}
      />
      <AttributeFilterModel
        visible={filterModal}
        handleCancel={() => setFilterModal(false)}
        handleOk={(values) => getFilterPlanAttributes(values, 1)}
        filterBy={filterBy}
      />
    </>
  );
}

export default PlanAttributes;
